import React from 'react';
import changelog from '../data/CHANGELOG.json';
import { Dialog } from './ui';

interface ReleaseNotesDialogProps {
    onClose: () => void;
}

interface ChangelogEntry {
    hash: string;
    date: string;
    subject: string;
    tag?: string;
}

interface Changelog {
    generatedAt: string;
    fromCommit: string;
    toCommit: string;
    commits: ChangelogEntry[];
}

const data = changelog as Changelog;

export const ReleaseNotesDialog: React.FC<ReleaseNotesDialogProps> = ({ onClose }) => {
    const deployedAt = data.generatedAt && data.generatedAt !== '1970-01-01T00:00:00Z'
        ? new Date(data.generatedAt).toLocaleString('de-DE', { dateStyle: 'medium', timeStyle: 'short' })
        : null;

    const description = deployedAt ? (
        <>
            Deployed {deployedAt}
            {data.fromCommit && (
                <>
                    {' '}— <span className="font-mono">{data.fromCommit}</span> bis{' '}
                    <span className="font-mono">{data.toCommit}</span>
                </>
            )}
        </>
    ) : undefined;

    return (
        <Dialog open onClose={onClose} title="Release Notes" description={description} size="lg">
            {data.commits.length === 0 ? (
                <p className="py-8 text-center text-sm italic text-muted">
                    Keine Release Notes für diesen Build verfügbar.
                </p>
            ) : (
                <ul className="flex max-h-[60vh] flex-col overflow-y-auto">
                    {data.commits.map((commit) => (
                        <React.Fragment key={commit.hash}>
                            {commit.tag && (
                                <li className="border-b border-line py-2 text-sm font-semibold text-brand">
                                    {commit.tag}:
                                </li>
                            )}
                            <li className="flex items-baseline gap-3 border-b border-line py-2">
                                <span className="w-14 shrink-0 font-mono text-xs text-muted">{commit.hash}</span>
                                <span className="w-20 shrink-0 text-xs text-muted">{commit.date}</span>
                                <span className="break-words text-sm text-ink">{commit.subject}</span>
                            </li>
                        </React.Fragment>
                    ))}
                </ul>
            )}
        </Dialog>
    );
};

export default ReleaseNotesDialog;
